import {
    RESET_VALIDATION_ERRORS_BY_FIELD,
    SET_VALIDATION_ERRORS,
    CHANGE_FILTER_VALUE,
    RESET_PAGE,
    CHANGE_DATA_TABLE_OPTIONS,
    FULLFILL_PATIENTS,
    FULLFILL_PATIENT,
    SET_EDITED_PATIENT,
    UPDATE_EDITED_PATIENT_FIELD,
    UPDATE_EDITED_PATIENT_VALIDATION,
    SET_CREATION_PATIENT,
    UPDATE_CREATION_PATIENT_FIELD,
    UPDATE_CREATION_PATIENT_VALIDATION
} from './available'

export default {
    [CHANGE_FILTER_VALUE](state, {filterName, value}) {
        state.filters[filterName] = value
    },
    [SET_VALIDATION_ERRORS](state, {context, value}) {
        state.errorMessagesByFields[context] = value
    },
    [RESET_VALIDATION_ERRORS_BY_FIELD](state, {context, fieldName}) {
        delete state.errorMessagesByFields[context][fieldName]
    },
    [RESET_PAGE](state) {
        state.dataTableOptions.page = 1
    },
    [CHANGE_DATA_TABLE_OPTIONS](state, options) {
        state.dataTableOptions = options
    },
    [FULLFILL_PATIENTS](state, {items, totalCount}) {
        state.patients = items
        state.totalPatients = totalCount
    },
    [FULLFILL_PATIENT](state, patient) {
        let index = _.findIndex(state.patients, function (item) {
            return item.id === patient.id
        })

        if (index >= 0) {
            state.patients.splice(index, 1, patient)
        } else {
            state.patients.push(patient)
        }
    },
    [SET_EDITED_PATIENT] (state, patientData) {
        state.editedPatient.data = {
            ..._.cloneDeep(patientData)
        }
    },
    [UPDATE_EDITED_PATIENT_FIELD](state, {fieldName, value}) {
        state.editedPatient.data[fieldName] = value
    },
    [UPDATE_EDITED_PATIENT_VALIDATION](state, {errorsByFields, reset = false}) {
        if (!reset) {
            state.editedPatient.validationErrorsByFields = {
                ...state.editedPatient.validationErrorsByFields,
                ...errorsByFields
            }
        } else {
            state.editedPatient.validationErrorsByFields = errorsByFields
        }


        state.editedPatient.isValid = _.flatten(_.values(state.editedPatient.validationErrorsByFields)).length  === 0
    },
    [SET_CREATION_PATIENT] (state, creationPatient) {
        state.creationPatient = _.cloneDeep(creationPatient)
    },
    [UPDATE_CREATION_PATIENT_FIELD](state, {fieldName, value}) {
        state.creationPatient.data[fieldName] = value
    },
    [UPDATE_CREATION_PATIENT_VALIDATION](state, {errorsByFields, reset = false}) {
        if (!reset) {
            state.creationPatient.validationErrorsByFields = {
                ...state.creationPatient.validationErrorsByFields,
                ...errorsByFields
            }
        } else {
            state.creationPatient.validationErrorsByFields = errorsByFields
        }


        state.creationPatient.isValid = _.flatten(_.values(state.creationPatient.validationErrorsByFields)).length  === 0
    },
}
